<template>
  <div>
    <!-- <my_slider
        titleWidth="54"
        :title="title"
        :value.sync="result"
        :min="0"
        :max="360"
        :precision="2"
        symbol="°"
    ></my_slider> -->
    <my_input_number
        titleWidth="0"
        class="slider-input"
        :value.sync="result"
        :min="0"
        :max="360"
        size="medium"
        :num-type="numType"
        :step="step"
        symbol="°"
        width="56"
        :precision="0"
        @change="change_input"
      />
  </div>
</template>

<script>
import my_input_number from '../my_input_number'
export default {
  name: 'MyRotateIndex',
  data() {
    return {
      result: this.value
    }
  },
  components: {
    my_input_number
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: '旋转'
    },
    numType: {
      type: String,
      default: 'int'
    },
    step: {
      // 步长
      type: Number,
      default: 1
    }
  },
  watch: {
    value(val) {
      this.result = val
    },
    result() {
      this.$emit('update:value', this.result)
    }
  },
  methods: {
    change_input(val) {
      this.result = Number(val)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
